import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const Separator = ({ children, color, ...props }) => (
  <Container
    position="relative"
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="1px"
    {...props}
  >
    <Container
      position="absolute"
      height="1px"
      width="100%"
      backgroundColor={color}
    />
    <Container position="relative" zIndex="1" backgroundColor="normal">
      {children}
    </Container>
  </Container>
);

Separator.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
};

Separator.defaultProps = {
  color: 'background800',
  children: null,
};

export default Separator;
